module.exports = __webpack_public_path__ + "img/9788990878519.5c8617bf.jpg";